import React, { useState } from 'react';
import { formsData } from '../../data/knowledgeBank/formsData';
import { FiFolder, FiExternalLink, FiDownload } from 'react-icons/fi';

export default function Forms() {
  const [activeSubTab, setActiveSubTab] = useState('standard');
  
  const standardList = formsData.standard || [];
  const cgstList = formsData.cgst || [];

  return (
    <div className="page-wrapper">
      <div className="page-hero">
        <h1>Utility <span>Forms</span></h1>
        <p>Download standard income tax, corporate filing, and GST forms</p>
      </div>

      <main style={{ padding: '60px 0', background: 'var(--off-white)' }}>
        <div className="container">
          {/* Main Tabs */}
          <div 
            style={{ 
              display: 'flex', 
              gap: '12px',
              marginBottom: '32px',
              borderBottom: '1px solid var(--gray-200)',
              paddingBottom: '12px'
            }}
          >
            <button
              onClick={() => setActiveSubTab('standard')}
              style={{
                padding: '12px 24px',
                fontSize: '1rem',
                fontWeight: 700,
                borderRadius: 'var(--radius-sm)',
                border: 'none',
                background: activeSubTab === 'standard' ? 'var(--primary)' : 'transparent',
                color: activeSubTab === 'standard' ? 'var(--white)' : 'var(--text-muted)',
                cursor: 'pointer',
                transition: 'all var(--transition)'
              }}
            >
              Standard Utility Forms
            </button>
            <button
              onClick={() => setActiveSubTab('cgst')}
              style={{
                padding: '12px 24px',
                fontSize: '1rem',
                fontWeight: 700,
                borderRadius: 'var(--radius-sm)',
                border: 'none',
                background: activeSubTab === 'cgst' ? 'var(--primary)' : 'transparent',
                color: activeSubTab === 'cgst' ? 'var(--white)' : 'var(--text-muted)',
                cursor: 'pointer',
                transition: 'all var(--transition)'
              }}
            >
              CGST Forms
            </button>
          </div>

          {/* Forms List Grid */}
          <div 
            style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', 
              gap: '24px' 
            }}
          >
            {activeSubTab === 'standard' ? (
              standardList.map((form) => (
                <div
                  key={form.id}
                  style={{
                    background: 'var(--white)',
                    border: '1px solid var(--gray-200)',
                    borderRadius: 'var(--radius-md)',
                    padding: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: '16px',
                    boxShadow: 'var(--shadow-sm)'
                  }}
                >
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <div 
                      style={{ 
                        color: 'var(--primary)',
                        background: 'rgba(25, 135, 84, 0.08)',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                      }}
                    >
                      <FiFolder size={20} />
                    </div>
                    <h3 
                      style={{ 
                        fontSize: '1.05rem', 
                        color: 'var(--text-dark)', 
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 700,
                        lineHeight: '1.4'
                      }}
                    >
                      {form.name}
                    </h3>
                  </div>

                  <a
                    href={form.originalUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-outline"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      padding: '10px 16px',
                      fontSize: '0.88rem',
                      borderRadius: 'var(--radius-sm)',
                      borderColor: 'var(--primary)',
                      color: 'var(--primary)',
                      background: 'transparent'
                    }}
                  >
                    <FiDownload size={14} /> Download Forms <FiExternalLink size={12} />
                  </a>
                </div>
              ))
            ) : (
              cgstList.map((form) => (
                <div
                  key={form.id}
                  style={{
                    background: 'var(--white)',
                    border: '1px solid var(--gray-200)',
                    borderRadius: 'var(--radius-md)',
                    padding: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: '16px',
                    boxShadow: 'var(--shadow-sm)'
                  }}
                >
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <div 
                      style={{ 
                        color: 'var(--secondary)',
                        background: 'rgba(13, 110, 253, 0.08)',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                      }}
                    >
                      <FiFolder size={20} />
                    </div>
                    <h3 
                      style={{ 
                        fontSize: '1.05rem', 
                        color: 'var(--text-dark)', 
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 700,
                        lineHeight: '1.4'
                      }}
                    >
                      {form.name}
                    </h3>
                  </div>

                  <a
                    href={form.originalUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-outline"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      padding: '10px 16px',
                      fontSize: '0.88rem',
                      borderRadius: 'var(--radius-sm)',
                      borderColor: 'var(--secondary)',
                      color: 'var(--secondary)',
                      background: 'transparent'
                    }}
                  >
                    <FiDownload size={14} /> Open CGST Forms <FiExternalLink size={12} />
                  </a>
                </div>
              ))
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
